import { cva, VariantProps } from 'class-variance-authority'
import { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react'
import { cn } from '../utilities.ts'

export const buttonVariants = cva(
  'font-semibold inline-flex justify-center items-center',
  {
    variants: {
      variant: {
        primary:
          'bg-primary-600 text-white disabled:cursor-not-allowed hover:bg-primary-500 disabled:bg-gray-200 disabled:text-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600',
        outline:
          'bg-white shadow-sm text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50',
        soft: 'bg-primary-50 text-primary-600 hover:bg-primary-100',
        ghost: 'text-gray-900 hover:bg-gray-50',
        danger: 'bg-red-600 text-white hover:bg-red-500  border-none',
        text: 'underline inline p-0 text-gray-800',
        dev_feature:
          'bg-secondary text-white hover:bg-[#84d9cb] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary',
      },
      size: {
        xs: 'rounded text-xs px-2 py-1',
        sm: 'rounded text-sm px-2 py-1',
        md: 'rounded-md px-2.5 py-1.5 text-sm',
        lg: 'rounded-md px-3 py-2 text-sm',
        xl: 'rounded-md text-sm px-3.5 py-2.5',
        text: 'p-0 text-sm',
      },
    },

    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
)

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  children: ReactNode
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, children, ...props }, ref) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    )
  }
)
Button.displayName = 'Button'
